import React from "react";

const Tabs = ({ activeTab, setActiveTab, tabData }) => {
  return (
    <div className="flex justify-start w-full mb-4">
      {Object.keys(tabData).map((tab, index) => (
        <button
          key={index}
          className={`px-4 py-2 text-sm font-normal ${
            activeTab === tab
              ? "bg-[#C2DFFF] text-[#2563EB] rounded-lg"
              : "text-[#303972]"
          } mr-4`}
          style={{ fontFamily: "sans-serif, Archivo" }}
          onClick={() => setActiveTab(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
